var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isEmpty, orderBy } from "lodash";
import { createBulkOrderRequest, createOrderRequest } from "src/apis/dashboard";
import { useAppDispatch } from "src/hooks/redux";
import { closeBuySellModal, openEdisModal, openOrderSummary, setSummaryOrdersDataList, closeBulkOrderPlacement, closeSelectedExpiry, } from "src/redux/reducers/modals";
import { marginUpdate } from "src/redux/reducers/non-persist";
import { captureCleverTabAnalytics } from "src/utils/analytics";
import { APP_SOURCE, EQUITY_SEGMENT } from "src/utils/constant";
import { generateRandomRemoteId, getOrderValidityFromDayType, getSegmentAndProductType, splitAndGetDetailsFromLongName, } from "src/utils/methods";
import { refreshNetPosition } from "../../../../redux/reducers/common-reducer";
import { SESSION_KEYS, setDataInSession, } from "../../../../utils/session-storage";
const { REACT_APP_VERSION, REACT_APP_ENV } = process.env;
const useOrderRequestHook = ({ validityDate, formType, priceType, price, stockQuantity, disclosedQuantity, timeType, stopLossTriggerPrice, dayType, productType, afterMarketHours, scripData, clientCode, lotSize, sliceLimitData, executeCallback, toggleSliceConsent, setLoading, }) => {
    const dispatch = useAppDispatch();
    const getRequestOrderReqJson = () => {
        var _a, _b;
        if (!isEmpty(validityDate)) {
            validityDate = validityDate
                .replace("/Date(", "")
                .replace(")/", "")
                .split("+")[0];
        }
        const validity = dayType == "vtd" && !isEmpty(validityDate)
            ? new Date(validityDate)
            : new Date();
        validity.setHours(23);
        validity.setMinutes(59);
        validity.setSeconds(59);
        validity.setMilliseconds(999);
        const reqJson = {
            clientCode: clientCode,
            exchange: scripData.exchange,
            exchangeType: scripData.exchangeType,
            scripCode: scripData.scripCode,
            transactionType: formType,
            atMarket: priceType == "market",
            price: priceType == "market" ? 0 : price,
            stockQuantity: stockQuantity,
            disclosedQuantity: disclosedQuantity,
            isStopLoss: timeType == "stoploss",
            stopLossTriggerPrice: timeType == "stoploss" ? stopLossTriggerPrice : 0,
            isVtd: dayType == "vtd",
            isIoc: dayType == "ioc",
            isIntraDay: productType == "intraday",
            afterMarketHours: afterMarketHours,
            validityTime: validity.getTime(),
            orderFor: scripData.orderFor,
            exchangeOrderId: scripData.orderFor == "P" ? "0" : (_a = scripData.orderData) === null || _a === void 0 ? void 0 : _a.ExchOrderID,
            iOrderValidity: getOrderValidityFromDayType(dayType),
            brokerOrderId: scripData.orderFor == "P" ? "" : (_b = scripData.orderData) === null || _b === void 0 ? void 0 : _b.BrokerOrderId,
        };
        return reqJson;
    };
    const isConsentRequired = () => {
        let returnValue = false;
        if (sliceLimitData && stockQuantity) {
            if (sliceLimitData.isConsentReceived) {
                // Consent already received so consent call not required
            }
            else if (sliceLimitData.qtyLimit < stockQuantity) {
                returnValue = true;
            }
        }
        return returnValue;
    };
    const isSplitOrderRequired = () => {
        let returnValue = false;
        if (sliceLimitData && stockQuantity) {
            if (sliceLimitData.qtyLimit < Number(stockQuantity)) {
                returnValue = true;
            }
        }
        return returnValue;
    };
    const getSplitOrderSingleJson = (quantity, validityTime, localOrderId, individualDisclosedQuantity) => {
        var _a;
        const singleOrderJson = {
            ClientCode: clientCode,
            OrderRequesterCode: clientCode,
            OrderFor: scripData.orderFor,
            Exchange: scripData.exchange,
            ExchangeType: scripData.exchangeType,
            ScripCode: scripData.scripCode,
            OrderType: formType,
            AtMarket: priceType == "market",
            Price: priceType == "market" ? 0 : price,
            // DisQty: disclosedQuantity,
            DisQty: individualDisclosedQuantity,
            IsStopLossOrder: timeType == "stoploss",
            StopLossPrice: timeType == "stoploss" ? stopLossTriggerPrice : 0,
            // IsVTD: dayType == "vtd",
            IOCOrder: dayType == "ioc",
            IsIntraday: productType == "intraday",
            AHPlaced: afterMarketHours,
            ValidTillDate: validityTime,
            // ValidTillDate: `/Date(${validityTime})/`,
            iOrderValidity: getOrderValidityFromDayType(dayType),
            // BrokerOrderId:
            //   scripData.orderFor == "P" ? "" : scripData.orderData?.BrokerOrderId,
            OrderID: 2,
            Qty: quantity,
            TradedQty: "0",
            // OrderDateTime: `/Date(${new Date().getTime()})/`,
            OrderDateTime: new Date().getTime(),
            RemoteOrderID: generateRandomRemoteId(),
            ExchOrderID: scripData.orderFor == "P" || !((_a = scripData.orderData) === null || _a === void 0 ? void 0 : _a.ExchOrderID)
                ? "0"
                : scripData.orderData.ExchOrderID + "",
            // PublicIP: "",
            AppSource: APP_SOURCE,
        };
        //handling for modification. Only first order will be modify and other orders will be purchase
        if (localOrderId != 1 && singleOrderJson.OrderFor == "M") {
            singleOrderJson.ExchOrderID = "0";
            singleOrderJson.OrderFor = "P";
        }
        return singleOrderJson;
    };
    const getSplitOrderJson = () => {
        if (!sliceLimitData) {
            return;
        }
        const outputArray = [];
        const remainingData = Number(stockQuantity) % sliceLimitData.qtyLimit;
        const loopLength = (Number(stockQuantity) - remainingData) / sliceLimitData.qtyLimit;
        if (!isEmpty(validityDate)) {
            validityDate = validityDate
                .replace("/Date(", "")
                .replace(")/", "")
                .split("+")[0];
        }
        const validity = dayType == "vtd" && !isEmpty(validityDate)
            ? new Date(validityDate)
            : new Date();
        validity.setHours(23);
        validity.setMinutes(59);
        validity.setSeconds(59);
        validity.setMilliseconds(999);
        const remainderDisclosedQuantity = Number(disclosedQuantity) % loopLength;
        const individualDisclosedQuantity = (Number(disclosedQuantity) - remainderDisclosedQuantity) / loopLength;
        // console.log(individualDisclosedQuantity);
        // console.log(remainderDisclosedQuantity, " :remainderDisclosedQuantity");
        for (let i = 0; i < loopLength; i++) {
            outputArray.push(getSplitOrderSingleJson((sliceLimitData === null || sliceLimitData === void 0 ? void 0 : sliceLimitData.qtyLimit) ? sliceLimitData === null || sliceLimitData === void 0 ? void 0 : sliceLimitData.qtyLimit : 0, validity.getTime(), i + 1, individualDisclosedQuantity));
        }
        if (remainingData > 0) {
            outputArray.push(getSplitOrderSingleJson(remainingData, validity.getTime(), loopLength + 1, remainderDisclosedQuantity));
        }
        return {
            ClientCode: clientCode,
            AppSource: APP_SOURCE,
            OrderRequestData: outputArray,
        };
    };
    const sendSplitOrder = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            const requestJson = getSplitOrderJson();
            const response = yield createBulkOrderRequest(requestJson);
            dispatch(setSummaryOrdersDataList(requestJson.OrderRequestData));
            if (response.data.body.Status == 0) {
                executeCallback(true);
                const orderResponseArray = [];
                const orderRequestData = requestJson.OrderRequestData;
                const nameBreakup = splitAndGetDetailsFromLongName(scripData.name);
                response.data.body.OrderResponseData.forEach((singleElement, i) => {
                    const correspondingReqElement = orderRequestData[i];
                    // expiry:nameBreakup.expiry
                    if (correspondingReqElement) {
                        orderResponseArray.push(Object.assign(Object.assign({}, singleElement), { name: nameBreakup.name, expiry: nameBreakup.expiry, scripType: nameBreakup.scripType, strikeRate: nameBreakup.strikeRate, IsIntraday: productType == "intraday", OrderType: formType, Qty: correspondingReqElement.Qty }));
                    }
                });
                dispatch(openOrderSummary({
                    orderResponseData: orderResponseArray,
                    // orderResponseData:
                    //   getDummyBulkOrderResponse().body.OrderResponseData,
                }));
            }
            else {
                executeCallback(false, "Something went wrong");
            }
            dispatch(refreshNetPosition(true));
        }
        catch (error) {
            executeCallback(false, "Something went wrong");
        }
        finally {
            setLoading(false);
        }
    });
    const isSplitOrderAllowed = () => {
        let returnValue = false;
        // if (REACT_APP_ENV == "staging" || REACT_APP_ENV == "development") {
        const scripTypeObject = getSegmentAndProductType(scripData.name, scripData.exchange, scripData.exchangeType);
        if (scripTypeObject.segmentType == EQUITY_SEGMENT) {
            returnValue = true;
        }
        // }
        return returnValue;
    };
    const sendOrderRequest = (reqJson) => __awaiter(void 0, void 0, void 0, function* () {
        if (isSplitOrderAllowed()) {
            if (isConsentRequired()) {
                toggleSliceConsent();
                return;
            }
            else if (isSplitOrderRequired()) {
                sendSplitOrder();
                return;
            }
        }
        try {
            setLoading(true);
            const response = yield createOrderRequest(reqJson.clientCode, reqJson.exchange, reqJson.exchangeType, reqJson.scripCode, reqJson.transactionType, reqJson.atMarket, reqJson.price, reqJson.stockQuantity, reqJson.exchangeOrderId || "0", reqJson.disclosedQuantity, reqJson.isStopLoss, reqJson.stopLossTriggerPrice, reqJson.isVtd, reqJson.isIoc, reqJson.isIntraDay, reqJson.afterMarketHours, reqJson.validityTime, reqJson.orderFor, reqJson.iOrderValidity, reqJson.brokerOrderId, reqJson.orderFor == "P"
                ? 0
                : scripData.orderData
                    ? scripData.orderData.TradedQty
                    : 0);
            // const response:any = { data: getDummyOrderResponse() };
            // if (REACT_APP_ENV == "development" || REACT_APP_ENV == "staging") {
            //   response.data.body.Status = -1;
            //   response.data.body.RMSResponseCode = -162;
            // }
            /* captureDetailedAnalytics(
                `${formType} FNO Stock`,
                scripData.name,
                reqJson.IsIntraday,
                stockQuantity.toString(),
                price
              );*/
            // if (window.dataLayer) {
            //   window.dataLayer.push({
            //     event: "FNO360",
            //     eventCategory: "FNO360",
            //     eventAction: `${formType} FNO Stock`,
            //     eventLabel: `${scripData.name} - ${reqJson.isIntraDay} - ${stockQuantity} - ${price}`,
            //   });
            // }
            if (response.data.body.Status == 0) {
                captureCleverTabAnalytics("Order request placed successfully", {
                    "Initiate source": "",
                    ClientCode: clientCode,
                    AHPLACED: reqJson.afterMarketHours,
                    ATMARKET: reqJson.atMarket,
                    DISQTY: reqJson.disclosedQuantity,
                    Exchange: reqJson.exchange,
                    ExchangeType: reqJson.exchangeType,
                    IOCOrder: reqJson.isIoc,
                    IsIntraday: reqJson.isIntraDay,
                    IsStopLossOrder: reqJson.isStopLoss,
                    IsVTD: reqJson.isVtd,
                    OrderDateTime: new Date().getTime(),
                    OrderFor: reqJson.orderFor,
                    OrderID: 4,
                    OrderType: reqJson.transactionType,
                    Price: reqJson.price,
                    PublicIP: "",
                    Qty: reqJson.stockQuantity,
                    RemoteOrderID: generateRandomRemoteId(),
                    ScripCode: reqJson.scripCode,
                    StopLossPrice: reqJson.stopLossTriggerPrice,
                    TradedQty: reqJson.orderFor == "P"
                        ? 0
                        : scripData.orderData
                            ? scripData.orderData.TradedQty
                            : 0,
                    "CT Web Version": REACT_APP_VERSION,
                    "CT Source": "Derivative360",
                    OrderForm: reqJson.DelvIntra,
                });
                // if (window.clevertap) {
                //   window.clevertap.event.push("Order request placed successfully", {
                //     "Initiate source": "",
                //     ClientCode: clientCode,
                //     AHPLACED: reqJson.afterMarketHours,
                //     ATMARKET: reqJson.atMarket,
                //     DISQTY: reqJson.disclosedQuantity,
                //     Exchange: reqJson.exchange,
                //     ExchangeType: reqJson.exchangeType,
                //     IOCOrder: reqJson.isIoc,
                //     IsIntraday: reqJson.isIntraDay,
                //     IsStopLossOrder: reqJson.isStopLoss,
                //     IsVTD: reqJson.isVtd,
                //     OrderDateTime: new Date().getTime(),
                //     OrderFor: reqJson.orderFor,
                //     OrderID: 4,
                //     OrderType: reqJson.transactionType,
                //     Price: reqJson.price,
                //     PublicIP: "",
                //     Qty: reqJson.stockQuantity,
                //     RemoteOrderID: "202205270455305",
                //     ScripCode: reqJson.scripCode,
                //     StopLossPrice: reqJson.stopLossTriggerPrice,
                //     TradedQty: scripData.orderData ? scripData.orderData.TradedQty : 0,
                //     "CT Web Version": REACT_APP_VERSION,
                //     "CT Source": "Derivative360",
                //     OrderForm: reqJson.DelvIntra,
                //   });
                // }
                executeCallback(true, scripData.orderFor == "P"
                    ? "Order placed successfully"
                    : "Order modified successfully");
            }
            else if (response.data.body.RMSResponseCode == -162) {
                // window.open(
                //   "https://tradestation.5paisa.com/ssologin?redirect=/portfolio",
                //   "_target"
                // );
                const localScripData = Object.assign(Object.assign({}, scripData), { timeType });
                const localOrderData = {
                    AtMarket: priceType == "market" ? "Y" : "N",
                    DelvIntra: "D",
                    DisClosedQty: disclosedQuantity,
                    MarketLot: lotSize,
                    OrderValidUpto: reqJson.validityTime,
                    OrderValidity: reqJson.iOrderValidity,
                    Qty: stockQuantity,
                    Rate: parseFloat(price),
                    SLTriggerRate: parseFloat(stopLossTriggerPrice),
                    WithSL: timeType == "stoploss" ? "Y" : "N",
                };
                localScripData.orderData = localOrderData;
                //const scripDataString = JSON.stringify(localScripData);
                setDataInSession(SESSION_KEYS.SCRIP_DATA, localScripData, true);
                dispatch(openEdisModal({
                    // ...scripData,
                    exchange: scripData.exchange,
                    exchangeType: scripData.exchangeType,
                    scripCode: scripData.scripCode,
                    quantity: Number(stockQuantity),
                }));
                dispatch(closeBuySellModal());
                dispatch(marginUpdate(true));
            }
            else {
                executeCallback(false, response.data.body.Message);
            }
        }
        catch (err) {
            executeCallback(false, "Something went wrong");
            console.error(err);
        }
        finally {
            setLoading(false);
            // console.log("Test,refresh");
            dispatch(refreshNetPosition(true));
        }
    });
    const executeOrder = (reqJsonparam) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        try {
            const bulkPayLoad = [];
            setLoading(true);
            const cloneBulkData = orderBy([...(scripData.bulkModifyArray ? scripData.bulkModifyArray : [])], ["isBuy"], "desc");
            const validity = new Date();
            validity.setHours(23);
            validity.setMinutes(59);
            validity.setSeconds(59);
            validity.setMilliseconds(999);
            cloneBulkData.forEach((singleBulk, index) => {
                const payload = {
                    ClientCode: clientCode,
                    OrderFor: "M",
                    Exchange: singleBulk.Exch,
                    ExchangeType: singleBulk.ExchType,
                    ScripCode: singleBulk.ScripCode,
                    OrderType: reqJsonparam.transactionType,
                    AtMarket: singleBulk.AtMarket == "N" ? false : true,
                    Price: singleBulk.AtMarket == "N" ? price : 0,
                    DisQty: 0,
                    IsStopLossOrder: reqJsonparam.isStopLoss,
                    StopLossPrice: reqJsonparam.stopLossTriggerPrice,
                    IOCOrder: reqJsonparam.isIoc,
                    IsIntraday: reqJsonparam.isIntraDay,
                    AHPlaced: singleBulk.AfterHours ? singleBulk.AfterHours : "Y",
                    ValidTillDate: `${validity.getTime()}`,
                    iOrderValidity: 0,
                    OrderID: 0,
                    Qty: singleBulk.Qty,
                    TradedQty: "0",
                    OrderDateTime: `${new Date().getTime()}`,
                    RemoteOrderID: generateRandomRemoteId(),
                    ExchOrderID: singleBulk.ExchOrderID,
                    // PublicIP: "",
                    OrderRequesterCode: clientCode,
                    AppSource: APP_SOURCE,
                    LastTradePrice: singleBulk.LastRate,
                    prevClose: singleBulk.PClose,
                    openedFrom: "bulkOrder",
                };
                bulkPayLoad.push(payload);
            });
            // bulkPayLoad = orderBy(bulkPayLoad, ["OrderType"], "asc");
            const reqJson = {
                ClientCode: clientCode,
                AppSource: APP_SOURCE,
                OrderRequestData: bulkPayLoad,
            };
            const response = yield createBulkOrderRequest(reqJson);
            // dispatch(setSummaryOrdersDataList(reqJson.OrderRequestData));
            if (response.data.body.Status == 0) {
                dispatch(closeBulkOrderPlacement());
                if (
                // response == null ||
                ((_b = (_a = response.data.body) === null || _a === void 0 ? void 0 : _a.OrderResponseData[0]) === null || _b === void 0 ? void 0 : _b.Status) == 0) {
                    executeCallback(true, "Order modified successfully.", response.data.body.Status);
                }
                else if (((_d = (_c = response.data.body) === null || _c === void 0 ? void 0 : _c.OrderResponseData[0]) === null || _d === void 0 ? void 0 : _d.RMSResponseCode) == -162) {
                    dispatch(openEdisModal({
                        exchange: scripData.exchange,
                        exchangeType: scripData.exchangeType,
                        scripCode: scripData.scripCode,
                        quantity: Number(stockQuantity),
                    }));
                    dispatch(closeBuySellModal());
                    dispatch(marginUpdate(true));
                }
                else {
                    executeCallback(false, (_f = (_e = response.data.body) === null || _e === void 0 ? void 0 : _e.OrderResponseData[0]) === null || _f === void 0 ? void 0 : _f.Message, response.data.body.Status);
                }
                dispatch(marginUpdate(true));
                dispatch(closeSelectedExpiry());
            }
            dispatch(refreshNetPosition(true));
            captureCleverTabAnalytics("Bulk Order Modify", {
                eventName: "Bulk Order Modify",
            });
        }
        catch (error) {
            console.error("Error ", error);
        }
        finally {
            setLoading(false);
            // marginUpdate(true);
            // dispatch(marginUpdate(true));
        }
    });
    return { getRequestOrderReqJson, sendOrderRequest, executeOrder };
};
export default useOrderRequestHook;
